export default "__VITE_ASSET__BWiASiYI__"